<template>
  <div
    id="off-canvas-wrap"
    class="off-canvas-wrap"
    data-offcanvas
  >
    <div class="inner-wrap">
      <div class="exit-off-canvas"/>
      <v-header v-if="showHeaderAndFooter" @switchLanguage="onLanguageSwitch"/>
      <div
        id="main"
        role="main"
      >
        <div class="content payment-flow">
          <div class="row">
            <div class="inner">
              <slot/>
            </div>
          </div>
        </div>
      </div>
      <v-footer v-if="showHeaderAndFooter" :key="language" />
    </div>
  </div>
</template>

<script>
import VHeader from '../components/Header'
import VFooter from '../components/Footer'
import { i18n } from '../plugins/vue-i18n'
import Cookies from 'js-cookie'
import xcHelperMixin from '../mixins/xc-helper'

export default {
  name: 'LayoutPaymentFlow',
  components: {
    VHeader,
    VFooter
  },
  mixins: [xcHelperMixin],
  data () {
    return {
      language: null,
      showHeaderAndFooter: !this.$container.config.runWithoutXC
    }
  },
  async created () {
    const language = Cookies.get('language')

    if (typeof language !== 'undefined') {
      i18n.locale = language
    }

    if (typeof this.$route.params.lang !== 'undefined') {
      i18n.locale = this.$route.params.lang

      if (i18n.locale !== language) {
        this.$router.push({
          ...this.$route,
          params: {
            lang: i18n.locale
          }
        }).catch(() => {})
      }
    }
  },
  methods: {
    onLanguageSwitch (language) {
      Cookies.set('language', language, {domain: this.arrivaXcCookieDomain})

      // Re-render footer
      this.language = language
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/PaymentFlow.vue